import { Flex, Box } from '@chakra-ui/react';
import { LoginForm } from '../Auth/LoginForm';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { Outlet } from 'react-router-dom';

interface DashboardLayoutProps {
  onLogout: () => void;
}

export function DashboardLayout({ onLogout }: DashboardLayoutProps) {
  return (
    <Flex minH="100vh" bg="gray.50">
      <Sidebar onLogout={onLogout} />
      <Box flex="1">
        <TopBar />
        <Outlet />
      </Box>
    </Flex>
  )
}
